
<div v-if="editor" class="overlay" ref="overlay" @mousedown="onToolbarMouseDown">
  <template v-if="isStyleShown">
    <div class="text-style-element" @click="onClickTextStyle">
      <div class="text-style-text">{{ $t(`textEditor.${activeTextStyle}`) }}</div>
      <n-icon class="info-icon" icon="chevron-down" size="xs" />
    </div>
    <div class="divider"></div>
  </template>

  <TextStyleDropdown :textStyle="textStyle" @onClick="applyTextStyle" ref="menu" />

  <n-tooltip v-if="isBoldShown" :tippyProps="tooltips.bold">
    <n-editor-button
      :active="isBoldActive"
      :disabled="!canFormatText"
      :aria-label="tooltips.bold.content"
      @click="toggleBold()"
      class="styling-element"
      high
    >
      <b>B</b>
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isItalicShown" :tippyProps="tooltips.italic">
    <n-editor-button
      :active="isItalicActive"
      :disabled="!canFormatText"
      :aria-label="tooltips.italic.content"
      @click="toggleItalic()"
      class="styling-element"
      high
    >
      <i>I</i>
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isUnderlinedShown" :tippyProps="tooltips.underline">
    <n-editor-button
      :active="isUnderlineActive"
      :disabled="!canFormatText"
      :aria-label="tooltips.underline.content"
      @click="toggleUnderline()"
      class="styling-element"
      high
    >
      <u>U</u>
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isStrikeShown" :tippyProps="tooltips.strike">
    <n-editor-button
      :active="isStrikeActive"
      :disabled="!canFormatText"
      :aria-label="tooltips.strike.content"
      @click="toggleStrike()"
      class="styling-element"
      high
    >
      <s>S</s>
    </n-editor-button>
  </n-tooltip>

  <template v-if="isAlignShown">
    <div class="divider"></div>
    <n-tooltip :tippyProps="tooltips.alignLeft">
      <n-editor-button
        :active="isTextAlignLeftActive"
        :aria-label="tooltips.alignLeft.content"
        @click="setTextAlign('left')"
        class="styling-element"
        high
      >
        <n-icon size="s" icon="align-left" />
      </n-editor-button>
    </n-tooltip>
    <n-tooltip :tippyProps="tooltips.alignCenter">
      <n-editor-button
        :active="isTextAlignCenterActive"
        :aria-label="tooltips.alignCenter.content"
        @click="setTextAlign('center')"
        class="styling-element"
        high
      >
        <n-icon size="s" icon="align-center" />
      </n-editor-button>
    </n-tooltip>
    <n-tooltip :tippyProps="tooltips.alignRight">
      <n-editor-button
        :active="isTextAlignRightActive"
        :aria-label="tooltips.alignRight.content"
        @click="setTextAlign('right')"
        class="styling-element"
        high
      >
        <n-icon size="s" icon="align-right" />
      </n-editor-button>
    </n-tooltip>
    <n-tooltip :tippyProps="tooltips.alignJustify">
      <n-editor-button
        :active="isTextAlignJustifyActive"
        :aria-label="tooltips.alignJustify.content"
        @click="setTextAlign('justify')"
        class="styling-element"
        high
      >
        <n-icon size="s" icon="align-justify" />
      </n-editor-button>
    </n-tooltip>
  </template>

  <div v-if="isLinkShown && isAnyListShown" class="divider"></div>
  <n-tooltip v-if="isOrderedListShown" :tippyProps="tooltips.orderedList">
    <n-editor-button
      :active="isOrderedListActive"
      :aria-label="tooltips.orderedList.content"
      @click="toggleOrderedList()"
      class="styling-element"
      high
    >
      <n-icon size="s" icon="ordered-list" />
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isBulletListShown" :tippyProps="tooltips.bulletList">
    <n-editor-button
      :active="isBulletListActive"
      :aria-label="tooltips.bulletList.content"
      @click="toggleBulletList()"
      class="styling-element"
      high
    >
      <n-icon size="s" icon="bullet-list" />
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isTaskListShown" :tippyProps="tooltips.taskList">
    <n-editor-button
      :active="isTaskListActive"
      :aria-label="tooltips.taskList.content"
      @click="toggleTaskList()"
      class="styling-element"
      high
    >
      <n-icon size="s" icon="checklist" />
    </n-editor-button>
  </n-tooltip>
  <div v-if="isLinkShown" class="divider"></div>
  <n-tooltip v-if="isLinkShown" :tippyProps="tooltips.link">
    <n-editor-button
      :active="isLinkActive"
      :aria-label="tooltips.link.content"
      @click="openLinkPopup()"
      class="styling-element"
      ref="linkbutton"
      high
    >
      <n-icon icon="link" size="s" />
    </n-editor-button>
  </n-tooltip>
  <n-tooltip v-if="isQuoteShown" :tippyProps="tooltips.quote">
    <n-editor-button
      :active="isBlockquoteActive"
      :aria-label="tooltips.quote.content"
      @click="toggleBlockquote()"
      class="styling-element"
      high
    >
      <n-icon icon="quote" size="s" />
    </n-editor-button>
  </n-tooltip>
  <LinkInput :link="linkValue" @updateLink="updateLink" @removeLink="removeLink" ref="linkInput" class="linkinput" />
</div>
